/* eslint-disable */
export default {
  participants: 'Osallistujat',
  host: '(ylläpitäjä)',
  removeParticipant: 'Poista osallistuja',
  removeTitle: 'Poista osallistuja',
  removeDescription: 'Poistetaanko {name} tästä neuvottelusta?',
  confirmButtonText: 'Poista',
  cancelButtonText: 'Peruuta',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
